<template>
  <div>
    <v-text-field
      :model-value="modelValue"
      :label="mustMatch !== null ? 'Bevestig wagwoord' : label"
      :type="visible ? 'text' : 'password'"
      :autocomplete="autocomplete"
      :rules="fieldRules"
      :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
      :hint="showHint ? `Minstens ${min} karakters; nie 'n algemene wagwoord of jou naam nie.` : undefined"
      :persistent-hint="showHint"
      @click:append-inner="visible = !visible"
      @update:model-value="$emit('update:modelValue', $event)"
    ></v-text-field>
    <div v-if="mustMatch === null && judge && strength && modelValue" class="mb-3" style="margin-top:-4px;">
      <v-progress-linear :model-value="strength * 25" :color="STRENGTH_COLORS[strength]" height="6" rounded></v-progress-linear>
      <div class="text-caption mt-1" style="color:var(--c-muted);">{{ STRENGTH_LABELS[strength] }}</div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { PASSWORD_MIN_LENGTH, STRENGTH_COLORS, STRENGTH_LABELS, passwordProblem, passwordStrength } from '@/utils/passwordRules';

// A password input with show/hide, the rule as a hint and a simple strength bar. With `mustMatch` set it
// becomes the "confirm" field instead (no hint or bar). The rule is only guidance here; the server enforces it.
export default {
  name: 'PasswordField',
  props: {
    modelValue: { type: String, default: '' },
    label: { type: String, default: 'Wagwoord' },
    email: { type: String, default: '' },
    firstName: { type: String, default: '' },
    lastName: { type: String, default: '' },
    mustMatch: { type: String, default: null },
    autocomplete: { type: String, default: 'new-password' },
    hint: { type: Boolean, default: true },
    // false for a "current password" field: it is only required, never judged
    judge: { type: Boolean, default: true },
    // may be left empty (e.g. when the account already exists); only judged once something is typed
    optional: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup(props) {
    const visible = ref(false);
    const context = computed(() => ({ email: props.email, firstName: props.firstName, lastName: props.lastName }));
    const showHint = computed(() => props.mustMatch === null && props.judge && props.hint);
    const fieldRules = computed(() => {
      if (props.mustMatch !== null) {
        return [(v) => !!v || 'Bevestig die wagwoord.', (v) => v === props.mustMatch || 'Die twee wagwoorde is nie dieselfde nie.'];
      }
      if (!props.judge) {
        return [(v) => !!v || 'Wagwoord is verpligtend.'];
      }
      return [(v) => (props.optional && !v) || passwordProblem(v, context.value) || true];
    });
    const strength = computed(() => (props.judge ? passwordStrength(props.modelValue, context.value) : 0));
    return { visible, fieldRules, strength, showHint, min: PASSWORD_MIN_LENGTH, STRENGTH_COLORS, STRENGTH_LABELS };
  },
};
</script>
